 <!--<section class="style-pictures-moodboard" id="{{section_id}}" *ngIf="stylePictures">-->

<!--    <h2 class="style-pictures-moodboard-title" id="moodboard">-->
<!--        <span>{{labels?.moodboard?.tuoMoodboard}}</span>-->
<!--    </h2>-->
<!--    <div class="grid masonry">-->
<!--        <div  #masonryItem class="masonry-item grid-item style-pictures-moodboard-item"-->
<!--          *ngFor="let image of stylePictures, let i = index">-->
<!--            <img [src]="image?.url"  (load)="onImageLoad()"  (click)="onShowImg(image?.url)">-->

<!--            <div class="moodboard-labels">-->
<!--                <h3> {{image?.categoryLabel}}</h3>-->
<!--                <h4> {{image?.name}}</h4>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->

<!--</section>-->

<section class="style-pictures-moodboard" id="{{section_id}}" *ngIf="stylePictures">

    <h2 class="style-pictures-moodboard-title" id="moodboard">
        <span>{{labels?.moodboard?.tuoMoodboard}}</span>
    </h2>

    <div #grid class="moodboard-grid">
        <div class="grid-sizer"></div>

        <div
                class="moodboard-item"
                *ngFor="let image of stylePictures; let i = index">

            <img
                    [src]="image?.url"
                    (load)="onImageLoad()"
                    (click)="onShowImg(image?.url)"
                    [alt]="image?.name">

            <div class="moodboard-labels"  *ngIf="image?.categoryLabel">
                <h3>{{image?.categoryLabel}}</h3>
                <h4>{{image?.name}}</h4>
            </div>

        </div>
    </div>

</section>

